import { useHistory, useRouteMatch } from "react-router-dom";
import { DefaultLayout } from "../../../layout";
import { LSDBCoreTable } from "../../../common/LSDBCoreTable";
import { Backdrop, Button, Chip, CircularProgress, Container, Grid, Paper, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme } from "@material-ui/core";
import React from "react";
import { LSDBCoreTableNoSrink } from "../../../common/LSDBCoreTableNoSrink";
import { getTheme } from "../../../common/getLocalTheme";
import { PrivateRoute } from "../../../auth/PrivateRoute";
import { NewAsset } from "./newAsset";
import { useAssets, useAssetsDisposition, useLocations } from "../../../intake/intakeQueries";
import { Error } from "@material-ui/icons";
import { formatDate } from "../../../common/formatDate";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { defaultColumn, useExpanded, useFilters, useGlobalFilter, useSortBy, useTable } from "react-table";
import { useDefaultColumn } from "../../../../util/filter";
import MuiTable from "@material-ui/core/Table";
import { AssetManegementTable } from "./assetManagementTable";
import LinkIcon from '@material-ui/icons/Link';
import { DataNotAvailable } from "../../../../plchina/DataNotAvailable";
import { useFetchContext } from "../../../common/FetchContext";
import moment from "moment";
import { urls } from "../../../common/urls";

export const AssetManagement = () => {


  if (localStorage.getItem("theme") === '2') {
    return (
      <DataNotAvailable />
    )
  }
  const { authAxios } = useFetchContext();

  const { path } = useRouteMatch();
  const theme = useTheme();
  const defaultColumn = useDefaultColumn();
  const history = useHistory();

  const [downloading, setDownloading] = React.useState(false);

  const {
    error: errorAsset,
    data: assets,
    isLoading: isLoadingAsset,
    isError: isErrorAsset,
  } = useAssets();
  const {
    error: errorAssetDisposition,
    data: assetsDisposition,
    isLoading: isLoadingAssetDisposition,
    isError: isErrorAssetDisposition,
  } = useAssetsDisposition();

  const handleDownload = async (): Promise<any> => {
    try {
      setDownloading(true);

      const response = await authAxios.get(urls.assets.DownloadAsset, {
        responseType: 'blob'
      });

      const downloadUrl = URL.createObjectURL(response.data);

      let a = document.createElement("a");
      a.href = downloadUrl;
      a.download = `${moment().format("MMM-DD-YYYY-HHMMSS")}`;
      document.body.appendChild(a);
      a.click();

      a.remove();
      URL.revokeObjectURL(downloadUrl);

    } catch (error) {
      console.error(error);
    } finally {
      setDownloading(false); // 🔥 always reset
    }
  };

  if (isLoadingAsset || isLoadingAssetDisposition) {
    return (
      <Backdrop open={isLoadingAsset || isLoadingAssetDisposition}>
        <CircularProgress></CircularProgress>
      </Backdrop>
    )
  }

  if (isErrorAsset) {
    return (
      <Error></Error>
    )
  }

  const newAsset = () => {
    history.push(`asset_management/new_asset`);
  };

  const linkAsset = () => {
    history.push(`asset_management/Link_asset`);
  };

  const revokeAsset = () => {
    history.push(`asset_management/revoke_asset`);
  };



  return (
    <>

      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={1}
        style={{ marginBottom: 15 }}
      >
        <Grid item xs={4}>
          <Typography variant="h3">Asset Management</Typography>
        </Grid>
        <Grid item xs={8}>
          <Grid container direction="row" spacing={2} justifyContent="flex-end">
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                disabled={getTheme() || downloading}
                onClick={handleDownload}
                startIcon={
                  downloading ? <CircularProgress size={18} color="inherit" /> : null
                }
              >
                {downloading ? "Downloading..." : "Download"}
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                disabled={getTheme()}
                onClick={revokeAsset}
              >
                View Revoked Assets
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                disabled={getTheme()}
                onClick={linkAsset}
                endIcon={<LinkIcon />}
              >
                View linked asset
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                disabled={getTheme()}
                onClick={newAsset}
                style={{ marginRight: "100px" }}
              >
                ADD NEW
              </Button>
            </Grid>
          </Grid>
        </Grid>

      </Grid>



      <AssetManegementTable assets={assets} assetDisposition={assetsDisposition} />



    </>


  );
};
